/* eslint-disable max-depth */
// Modules
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

// Application
import { getQueryParamsValue } from 'utils'
import { useLoginHook } from 'hooks'

// Components
import { FullPageLoading } from 'components'
import { goToPage } from 'redesign/utils/goToPage'
import { defaultConfig } from 'modules/RemoteConfig/defaultConfig'
import { useRemoteConfig } from 'modules/RemoteConfig/hooks/useRemoteConfig'

export const LoginAuto = () => {
    const { authenticateWithHash } = useLoginHook()

    const { getConfigByName } = useRemoteConfig()

    const location = useLocation()

    const autoLoginParamHash: string | null = getQueryParamsValue(location, 'h') || null
    const fapParam: string | undefined = getQueryParamsValue(location, 'fap') || undefined
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (autoLoginParamHash) {
            authenticateWithHash({ autoLoginParamHash, fapParam }, { setLoading })
        } else {
            goToPage(getConfigByName('AUTH_REDIRECT_LOGIN') || defaultConfig.strings.AUTH_REDIRECT_LOGIN)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [autoLoginParamHash])

    return <>{loading && <FullPageLoading />}</>
}
